import { Map } from 'immutable';
import { createSelector } from 'reselect';
import { PROMOTION_DETAILS_KEY } from './constants';

const selectQuickShop = () => (state) =>
  state.get(PROMOTION_DETAILS_KEY, Map());

export const selectPromotionAssets = () =>
  createSelector(selectQuickShop(), (landing) =>
    landing.get('promotionAssets'),
  );

export const selectIsPromoAssetsFetching = () =>
  createSelector(selectQuickShop(), (landing) =>
    landing.get('fetchingPromotionAssets'),
  );

export const selectPromotionalDetails = () =>
  createSelector(selectQuickShop(), (landing) =>
    landing.get('promotionalDetails'),
  );
